class IdleTimer {
  constructor({timeout, onTimeout}) {
    this.timeout = timeout
    this.onTimeout = onTimeout
    this.eventHandler = this.updateExpiredTime.bind(this)
    this.tracker()
    this.startInterval()
  }

  startInterval() {
    this.updateExpiredTime()
    this.interval = setInterval(() => {
      if (this.expiredTime < Date.now()) {
        if (this.onTimeout) {
          this.onTimeout()
        }
      }
    }, 1000)
  }

  updateExpiredTime() {
    this.expiredTime = Date.now() + this.timeout * 1000
  }

  tracker() {
    globalThis.addEventListener('mousemove', this.eventHandler)
    globalThis.addEventListener('click', this.eventHandler)
    globalThis.addEventListener('scroll', this.eventHandler)
    globalThis.addEventListener('keydown', this.eventHandler)
  }

  cleanUp() {
    clearInterval(this.interval)
    globalThis.removeEventListener('mousemove', this.eventHandler)
    globalThis.removeEventListener('scroll', this.eventHandler)
    globalThis.removeEventListener('click', this.eventHandler)
    globalThis.removeEventListener('keydown', this.eventHandler)
  }
}
export default IdleTimer
